import { Typography } from '@mui/material';
import { styled } from '@mui/system';

import { callNumber } from '../../../../assets/images/svgs';

const ContentContainer = styled('div')((props) => ({
    marginTop: 100,
    display: 'flex',
    flexDirection: 'column',
    width: '60%',
    [props.theme.breakpoints.down('md')]: {
        width: '100%',
        marginLeft: 20,
        marginRight: 20
    },
    '.welcome-text': {
        fontSize: 22,
        color: 'white',
        marginTop: 40,
        marginBottom: 40,
        [props.theme.breakpoints.down('md')]: {
            textAlign: 'center',
            fontSize: 20,
        }
    },
    '.tag-line': {
        color: 'white',
        fontSize: 80,
        marginBottom: 40,
        fontWeight: 900,
        [props.theme.breakpoints.down('md')]: {
            fontSize: 40,
            fontWeight: 600,
            textAlign: 'center'
        },
        [props.theme.breakpoints.down('sm')]:{
            fontSize: 30,
        }
    },
    '.phone-container': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 100
    },
    '.phone-icon-container': {
        width: 80,
        height: 80,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'white',
        borderRadius: '50%',
        [props.theme.breakpoints.down('md')]: {
            width: 50,
            height: 50,
            svg: {
                height: 30,
                width: 30
            }
        },
        [props.theme.breakpoints.down('sm')]: {
            width: 30,
            height: 30,
            svg: {
                height: 20,
                width: 20
            }
        }
    },
    '.phone-numbers': {
        marginLeft: 10,
        marginRight: 10,
        fontSize: 30,
        color: 'white',
        fontWeight: 800,
        textAlign: 'center',
        [props.theme.breakpoints.down('md')]:{
            fontSize:30
        },
        [props.theme.breakpoints.down('sm')]:{
            fontSize:20
        }
    }
}))

export const TopBanner = () => (
    <div style={{
        backgroundImage: 'url(' + require('../../../../assets/images/dog-base.jpeg') + ')',
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

    }}>
        <ContentContainer>
            <Typography className="welcome-text" variant="h6">Welcome to Furry Fort</Typography>
            <Typography className="tag-line" variant="h1">Your pet's perfect home away from home</Typography>
            <div className="phone-container">
                <div className="phone-icon-container">
                    {callNumber}
                </div>
                <Typography className="phone-numbers">+91-8826721342,+91-8826721343</Typography>
                
            </div>
        </ContentContainer>
        <img src={require('../../../../assets/images/banner-shape.png')} style={{ width: '100%' }} />
    </div>)